function handleEscapeKeyAndStopPropogation(event) {
  if (event.key === "Escape") {
    event.stopPropagation();
    return true;
  }
  return false;
}

export { handleEscapeKeyAndStopPropogation as h };
